import { render, staticRenderFns } from "./VersionSelector.vue?vue&type=template&id=a9cf5ae4&scoped=true"
import script from "./VersionSelector.vue?vue&type=script&lang=ts"
export * from "./VersionSelector.vue?vue&type=script&lang=ts"
import style0 from "./VersionSelector.vue?vue&type=style&index=0&id=a9cf5ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cf5ae4",
  null
  
)

export default component.exports